import React, { useState } from "react";
import OtpInput from "react-otp-input";
import Image from "react-bootstrap/Image";
import { Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { IMAGES } from "../../../assets/images/images";

const UserOTP = () => {
  const [otp, setOtp] = useState("");
  return (
    <section className="login_box">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-6 hideloginimg">
            <div className="login_bg">
              <Image src={IMAGES.Login_Bg} className="img-fluid" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="loginBody">
              <Form>
                <h1>Verify OTP</h1>
                <p className="para">
                  Enter the OTP sent to your registered email address
                </p>

                <div className="otpBox">
                  <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    renderInput={(props) => <input {...props} />}
                  />
                </div>

                <div className="text-end">
                  <Link className="forgotPassword textLineUnder">
                    Resend OTP
                  </Link>
                </div>

                <Button
                  as={Link}
                  to="/user-resetpassword"
                  className="btn btn-primary my-3 mb-4 my-mb-3 mb-md-3 my-lg-3 w-100"
                >
                  Continue
                </Button>

                <p className="text-center">
                  Back To{" "}
                  <Link
                    to="/user-forgotpassword"
                    className="forgotPassword forgotPassword1"
                  >
                    Forgot Password
                  </Link>
                </p>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UserOTP;
